// eslint-disable-next-line import/prefer-default-export
export const notificationsTotalUnreadSerializer = (data = {}) => {
  const newData = {
    totalUnread: null
  }

  const { data: innerData = {} } = data
  const { totalUnread = 0 } = innerData

  newData.totalUnread = totalUnread

  return newData
}
